import sanitizeHTML from './sanitizeHTML';

interface CleanOptions {
  sanitize?: boolean;
  stripNbsp?: boolean;
  fixBrokenLinks?: boolean;
  removeEmptyTags?: boolean;
  externalLinks?: boolean;
}

export const useCleanHtml = () => {
  const { hostname } = useUrl();

  const clean = (rawHtml: string | null | undefined, options: CleanOptions = {}) => {
    if (!rawHtml) return '';

    const {
      sanitize = true,
      stripNbsp = true,
      fixBrokenLinks = true,
      removeEmptyTags = true,
      externalLinks = false,
    } = options;

    let processed = rawHtml;

    if (stripNbsp) {
      processed = processed.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
    }

    if (removeEmptyTags) {
      // Uitleg Regex:
      // Group 1: <([a-z][a-z0-9]*) ... >  -> De openings tag naam (bijv 'strong')
      // Group 2: (\s*)                   -> DE WITRUIMTE (spaties, enters)
      // <\/\1>                           -> De sluit tag (bijv '/strong')
      const emptyTagRegex = /<([a-z][a-z0-9]*)[^>]*>(\s*)<\/\1>/gi;

      let oldContent = '';
      let loops = 0;

      while (processed !== oldContent && loops < 5) {
        oldContent = processed;
        processed = processed.replace(emptyTagRegex, '$2');
        loops++;
      }
    }

    if (fixBrokenLinks) {
      processed = processed.replace(/href="([^"]*?)[\s\u00A0]+"/g, 'href="$1"');
      processed = processed.replace(/href="([^"]*?)%20"/g, 'href="$1"');
    }

    if (sanitize) {
      processed = sanitizeHTML(processed, {
        ALLOWED_TAGS: ['a', 'b', 'i', 'br', 'strong', 'em', 'p', 'span', 'ul', 'li', 'ol'],
        ADD_ATTR: ['target', 'allow', 'rel'], // Sta target="_blank" en rel toe
      });

      if (externalLinks) {
        processed = processed.replace(/<a\s+([^>]*?)>/gi, (match, attrs) => {
          const hrefMatch = attrs.match(/href="([^"]*?)"/i);
          if (!hrefMatch) return match;

          const href = hrefMatch[1];
          let target = '';
          let rel = '';

          if (href.includes('format=pdf')) {
            target = '_blank';
          } else if (href.includes(hostname) || !href.startsWith('http')) {
            target = '_self';
          } else {
            target = '_blank';
            rel = 'noopener noreferrer';
          }

          let newAttrs = attrs.replace(/(?:\s+|^)(?:target|rel)="[^"]*"/gi, '').trim();
          if (target) newAttrs += ` target="${target}"`;
          if (rel) newAttrs += ` rel="${rel}"`;

          return `<a ${newAttrs}>`;
        });
      }
    }

    return processed;
  };

  return {
    clean,
  };
};
